export default __webpack_public_path__ + "static/media/status_inactive.4d61ae77.svg";